import clsx from 'clsx';
import Lottie from 'react-lottie';

import { WithAnimation } from 'helpers/routeTransitions/MountTransition';
import failedAnimationData from 'lotties/FailedSad.json';
import animationData from 'lotties/NotFound.json';

import {
  FinalScreenContainer,
  ImageWrapper,
  ErrorIcon,
  StyledButton,
  InfoWrapper,
} from './FinalScreen.style';

type Props = {
  message: string;
  handler: () => void;
  title: string;
  type?: string;
};

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
const sadFailed = {
  loop: true,
  autoplay: true,
  animationData: failedAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const ErrorScreen = ({ message, handler, title, type }: Props) => {
  return (
    <FinalScreenContainer data-cy='error-container'>
      <ImageWrapper className={clsx('', { errorTypeWrapper: type === 'error' })}>
        {type === 'error' ? (
          <Lottie options={sadFailed} width={'200px'} height={'200'} />
        ) : (
          <Lottie options={defaultOptions} />
        )}
      </ImageWrapper>
      <InfoWrapper>
        <div className='header'>
          <ErrorIcon />
          <span>Failure</span>
        </div>
        <div className='wrapper'>
          <p className='errorMessage'>{message}</p>
        </div>
        <StyledButton onClick={handler}>{title}</StyledButton>
      </InfoWrapper>
    </FinalScreenContainer>
  );
};

export default WithAnimation(ErrorScreen);
